export default {
    header: {
        telefone: "Телефон",
        signIn: "Войти",
        register: "Зарегистрироваться",
        becomeExpert: "Зарегистрируйте свою компанию",
        dashboard: "Панель управления",

        sidebar: {
            tuktuk: {
                title: "Тук-тук",
                subtitle: "Бронирование тук-тука",
                menu: {
                    grid: "Список тук-туков",
                },
            },
            about: {
                title: "О нас",
                subtitle: "О нас",
                menu: {
                    aboutUs: "О нас",
                    testimonials: "Отзывы",
                    faq: "Часто задаваемые вопросы",
                    contact: "Связаться с нами",
                    terms: "Условия и положения",
                    privacy: "Политика конфиденциальности",
                },
            },
            dashboard: {
                title: "Панель управления",
                subtitle: "Панель пользователя",
                subtitle2: "Панель агента",
                menu: {
                    dashboard: "Панель управления",
                    myBookings: "Мои бронирования",
                    reviews: "Отзывы",
                    support: "Поддержка",
                    wishlist: "Список желаний",
                    wallet: "Кошелек",
                    profileSettings: "Настройки профиля",
                    notifications: "Уведомления",
                    myProfile: "Мой профиль",
                    settings: "Настройки",
                    dashboard2: "Панель управления",
                    bookings: "Бронирования",
                    enquiries: "Запросы",
                    earnings: "Заработки",
                    reviews2: "Отзывы",
                    settings2: "Настройки",
                },
            },
            social: {
                title: "Социальная сеть",
                subtitle: "Лента публикаций",
                menu: {
                    feed: "Лента",
                    myProfilePage: "Моя страница профиля",
                    explore: "Исследовать",
                },
            },
        },
    },

    common: {
        welcome: "Добро пожаловать, {{name}}!",
    },

    home: {
        hero: {
            title: "Приблизьтесь к мечте:",
            title2: "основные вещи для вашего путешествия ждут",
            title3: "вас",
            subtitle: "Ваше главное место для всего, что помогает отметить и запомнить ваш опыт путешествия.",
            tukTuk: "Тук-тук",
        },
        searchBy: {
            titlePrefix: "Последние",
            titleSuffix: "пакеты",
            subtitle:
                "Откройте для себя новейшие пакеты, добавленные в Portugalwaytour, и исследуйте уникальные возможности для путешествий, тщательно отобранные, чтобы предоставить вам незабываемые впечатления, новые направления и эксклюзивные приключения по всему миру.",
            noPackages: "Не найдено недавних пакетов.",
            hasDiferencial: "Имеет отличие",
            noReviews: "Нет отзывов",
            viewAll: "Посмотреть все пакеты",
        },
        sectionBenefit: {
            titlePrefix: "Наши",
            titleHighlight: "Преимущества",
            titleSuffix: "и основные достоинства",
            subtitle:
                "Portugalway, туроператор, специализирующийся на направлениях мечты, предлагает ряд преимуществ для путешественников.",
            benefits: [
                {
                    title: "Подлинные впечатления",
                    description:
                        "Избегайте традиционного туризма и откройте для себя подлинную Португалию! Наши туры предлагают настоящие впечатления, исследуя местную культуру, кухню и секретные места.",
                },
                {
                    title: "Персонализированные туристические пакеты",
                    description:
                        "Создайте свое индивидуальное путешествие! Выберите свой опыт, и мы позаботимся обо всем: проживание, транспорт и мероприятия, для персонализированного и незабываемого путешествия.",
                },
                {
                    title: "Комфорт и Безопасность",
                    description:
                        "Мы заботимся обо всех деталях: комфортабельный транспорт, выбранное жилье и сопровождение профессиональных гидов, гарантируя спокойствие от начала до конца поездки.",
                },
                {
                    title: "Выделенное обслуживание",
                    description:
                        "От первого контакта до возвращения из поездки вы получаете персонализированную поддержку и команду, готовую помочь на португальском и английском языках, с оперативностью и полным вниманием к вашим потребностям.",
                },
            ],
        },
        exploreCities: {
            title: "Исследовать по городу",
            subtitle: "Откройте для себя уникальные впечатления в невероятных направлениях",
        },
        placeSection: {
            titlePrefix: "Популярные",
            titleHighlight: "пакеты",
            subtitle:
                "Изучите наши самые популярные туристические пакеты, тщательно отобранные по высоким оценкам, положительным отзывам и частым бронированиям от других путешественников. Найдите свое следующее незабываемое приключение здесь.",
            all: "Все",
            hasDiferencial: "Имеет отличие",
            noReviews: "Нет отзывов",
            viewAll: "Посмотреть все пакеты",
        },
        aboutSection: {
            welcome: "Добро пожаловать в Portugalwaytour",
            title: "Исследуйте за горизонтом: откройте для себя чудеса света",
            description1: "В Portugal Way Tour мы верим, что путешествия - это трансформация. Мы - агентство, специализирующееся на уникальных туристических впечатлениях в Португалии, стремящееся раскрыть лучшее, что есть в стране — ее культуру, пейзажи, историю и подлинность.",
            point1: "Обеспечивать незабываемые поездки с комфортом, безопасностью и очарованием. Мы хотим, чтобы каждый турист глубоко открывал для себя Португалию, с маршрутами, которые сочетают традиции, природу, гастрономию и подлинное гостеприимство.",
            point2: "Быть эталоном качества и доверия в туризме Португалии, признанным туристами со всего мира как синоним профессионализма и очарования.",
            learnMore: "Узнать больше",
            reviews: "{{count}}+ Отзывов"
        },
        aboutCounters: [
            { label: "Направления по всему миру", icon: "isax-global5", colorClass: "text-teal" },
            { label: "Завершенные бронирования", icon: "isax-calendar-2", colorClass: "text-purple" },
            { label: "Клиенты по всему миру", icon: "isax-tag-user5", colorClass: "text-pink" },
            { label: "Зарегистрированные поставщики", icon: "isax-status-up5", colorClass: "text-info" },
        ],
        expertSection: {
            popularTitle: "Популярные",
            popularSubtitle: "Откройте для себя самые популярные, высоко оцененные и часто бронируемые услуги путешественниками.",
            serviceName: "Водитель тук-тука",
            loading: "Загрузка...",
            reservationsSingular: "бронирование",
            reservationsPlural: "бронирования",
            viewProfile: "Просмотреть профиль",
            viewAll: "Посмотреть все",
        },
        driverModal: {
            loading: "Загрузка...",
            description: "Описание",
            languages: "Языки",
            vehicle: "Транспортное средство",
            seats: "мест",
            averageRating: "Средняя оценка",
            reviews: "Отзывы",
            packages: "Пакеты",
            noReviews: "Пока нет отзывов",
            noPackages: "У этого водителя нет зарегистрированных пакетов"
        },
        testimonialSection: {
            title: "Что говорят наши {{highlight}}",
            highlight: "пользователи",
            subtitle: "Посмотрите, что наши путешественники думают о своем опыте.",
            loading: "Загрузка отзывов...",
            noReviews: "Отзывов не найдено.",
            noComment: "Пользователь не оставил комментарий.",
            viewPackage: "Посмотреть детали пакета"
        },
        updateSection: {
            faq: {
                title: "Часто задаваемые {{highlight}}",
                highlight: "вопросы",
                subtitle: "Portugalway, туроператор, специализирующийся на направлениях мечты, предлагает ряд преимуществ для путешественников.",
                questions: [
                    {
                        question: "Как забронировать тур?",
                        answer: "Вы можете забронировать тур напрямую на нашем сайте или связаться с нами по электронной почте или телефону. После выбора желаемого маршрута мы предоставим вам смету, подтвердим бронирование отелей и услуг, а также запросим оплату в соответствии с указанной политикой."
                    },
                    {
                        question: "Можно ли персонализировать маршрут?",
                        answer: "Да! Все наши маршруты гибкие. Вы выбираете места, которые хотите посетить, продолжительность, тип проживания, и, в рамках возможностей, мы создадим что-то, что соответствует вашему профилю."
                    },
                    {
                        question: "Какие языки говорят гиды?",
                        answer: "У нас есть гиды, которые говорят на португальском, английском и, в зависимости от тура, на других языках. Сообщите свои предпочтения при бронировании, чтобы мы могли назначить наиболее подходящего гида."
                    },
                    {
                        question: "Какова политика отмены бронирования?",
                        answer: "У нас есть политика отмены, которая варьируется в зависимости от тура, срока до начала и поставщиков. При бронировании мы высылаем полные условия. Просим внимательно прочитать их перед подтверждением."
                    },
                    {
                        question: "Какие формы оплаты принимаются?",
                        answer: "Мы принимаем международные банковские переводы, кредитные карты и, в некоторых случаях, другие способы оплаты."
                    }
                ],
                contactUsText: "Если вы не нашли ответ на свой вопрос в разделе «Часто задаваемые вопросы», свяжитесь с нами. Мы ответим в ближайшее время!",
                contactButton: "Связаться с нами",
            },
            support: {
                items: [
                    "Персонализированные маршруты",
                    "Полное планирование",
                    "Консультации экспертов",
                    "Местный опыт",
                    "Поддержка клиентов",
                    "Усилия по устойчивому развитию",
                    "Несколько регионов"
                ]
            }
        }
    },
    footer: {
        pages: {
            title: "Страницы",
            settings: "Настройки",
            profile: "Профиль",
            social: "Социальная сеть",
        },
        company: {
            title: "Компания",
            about: "О нас",
            testimonials: "Отзывы",
            faq: "Часто задаваемые вопросы",
        },
        support: {
            title: "Поддержка",
            contact: "Связаться с нами",
            privacy: "Политика конфиденциальности",
            terms: "Условия и положения",
            chat: "Поддержка в чате",
        },
        services: {
            title: "Услуги",
            tuktuk: "Тук-тук",
            winery: "Винодельня",
            restaurant: "Ресторан",
            car: "Автомобиль",
            hippotrip: "Гиппотрип",
            bike: "Велосипед",
        },
        bottom: {
            copyright: "Авторские права © 2025. Все права защищены,",
            brand: "Portugalwaytour",
            social: [
                { icon: "fa-brands fa-facebook", link: "#" },
                { icon: "fa-brands fa-x-twitter", link: "#" },
                { icon: "fa-brands fa-instagram", link: "#" },
                { icon: "fa-brands fa-linkedin", link: "#" },
                { icon: "fa-brands fa-pinterest", link: "#" },
            ],
            cards: [
                "assets/img/icons/card-01.svg",
                "assets/img/icons/card-02.svg",
                "assets/img/icons/card-03.svg",
                "assets/img/icons/card-04.svg",
                "assets/img/icons/card-05.svg",
                "assets/img/icons/card-06.svg",
            ],
        },
    },

    auth: {
        registerModal: {
            title: "Доступ к вашей учетной записи",
            subtitle: "Введите свой адрес электронной почты, чтобы войти или создать учетную запись",
            emailLabel: "Электронная почта",
            emailPlaceholder: "Введите свой адрес электронной почты",
            sendTestCode: "Отправить тестовый код",
            sendEmailCode: "Отправить код по электронной почте",
            codeLabel: "Код подтверждения",
            codePlaceholder: "Введите код",
            verifyAndLogin: "Подтвердить и войти",
            testCodeSuccess: "Тестовый код '123456' сгенерирован. Используйте для входа.",
            testCodeError: "Ошибка при генерации тестового кода.",
            emailSent: "Код отправлен на вашу электронную почту!",
            emailError: "Ошибка при отправке кода по электронной почте.",
            loginSuccess: "Вход выполнен успешно!",
            invalidCode: "Неверный или просроченный код.",
            or: "Или",
            google: "Google",
            facebook: "Facebook",
            reminderTitle: "Завершите свой профиль",
            reminderText: "Не забудьте заполнить свой профиль, чтобы воспользоваться всеми функциями платформы!",
            gotIt: "Понятно",
        },
    },
    companyRegisterModal: {
        title: "Регистрация компании",
        step1: "Пожалуйста, введите свой личный адрес электронной почты, чтобы создать учетную запись администратора компании. Вы будете использовать эту учетную запись для управления профилем компании.",
        step2: "Мы отправили код подтверждения на ваш адрес электронной почты. Введите его ниже, чтобы подтвердить свою личность.",
        step3: "Теперь заполните данные вашей компании. Адрес электронной почты компании должен быть корпоративным контактом (например: info@empresa.com).",

        personalEmail: "Ваш личный адрес электронной почты",
        sendTestCode: "Отправить тестовый код",
        sendEmailCode: "Отправить код по электронной почте",

        verificationCode: "Код подтверждения",
        verifyCode: "Подтвердить код",

        companyEmail: "Электронная почта компании",
        companyName: "Название компании",
        nif: "Идентификационный номер налогоплательщика (NIF)",
        nib: "Банковский идентификационный номер (NIB)",
        permanentCertificate: "Номер постоянного свидетельства",
        phone: "Телефон",
        street: "Улица",
        city: "Город",
        postalCode: "Почтовый индекс",
        country: "Страна",
        companyDescription: "Краткое описание компании",
        servicesProvided: "Предоставляемые услуги",

        contractTitle: "Договор компании",
        acceptContract: "Я принимаю договор компании",
        finishRegistration: "Завершить регистрацию",

        messages: {
            "Test code sent successfully. Use '123456'.": "Тестовый код успешно отправлен. Используйте '123456'.",
            "Verification email sent successfully.": "Письмо с подтверждением успешно отправлено.",
            "Verification successful.": "Подтверждение успешно.",
            "Company registered and contract accepted successfully!": "Компания зарегистрирована, и договор успешно принят!",
            testStepMessage: "Тестовый код успешно отправлен. Используйте '123456'.",
            emailStepMessage: "Код подтверждения был отправлен на ваш адрес электронной почты. Введите его ниже."
        },

        errors: {
            "Failed to send the verification code.": "Не удалось отправить код подтверждения.",
            "Invalid or expired code.": "Неверный или просроченный код.",
            "Please fill all required fields.": "Пожалуйста, заполните все обязательные поля.",
            "You must accept the contract to register the company.": "Вы должны принять договор для регистрации компании.",
            "You must be logged in to register the company.": "Вы должны быть авторизованы для регистрации компании.",
            "Failed to register the company or accept the contract.": "Не удалось зарегистрировать компанию или принять договор."
        }
    },
    chooseUsSection: {
        title: "Почему выбирают нас?",
        cards: [
            {
                title: "Удобство",
                description: "Планируйте всю свою поездку с одной платформы, экономя время и силы. Больше не нужно переключаться между разными сайтами."
            },
            {
                title: "Гарантия лучшей цены",
                description: "Мы работаем с надежными партнерами по путешествиям, чтобы предложить вам лучшие предложения, будь то бронирование рейса, отеля или аренда автомобиля."
            },
            {
                title: "Поддержка клиентов",
                description: "Наша специализированная служба поддержки доступна круглосуточно и без выходных, гарантируя, что ваши планы поездок пройдут гладко от начала до конца."
            },
            {
                title: "Персонализированные впечатления от путешествий",
                description: "Независимо от того, путешествуете ли вы по делам, в отпуск с семьей или в одиночное приключение, мы предлагаем варианты, которые отвечают всем потребностям."
            }
        ]
    },

    contactUsSection: {
        breadcrumb: {
            home: "Главная",
            pages: "Страницы",
            contactUs: "Контакты"
        },
        title: "Свяжитесь с нашей специализированной командой поддержки",
        description: "Наша команда готова помочь. Ваше удовлетворение - наш приоритет.",
        info: [
            {
                label: "Адрес электронной почты",
                value: "portugaltourway@gmail.com"
            },
            {
                label: "Номер телефона",
                value: "INSERT NUMBER"
            },
            {
                label: "Наше местоположение",
                value: "INSERT RUA , Almada - Португалия"
            }
        ],
        supportCard: {
            title: "Нужна поддержка?",
            textLoggedOut: "Чтобы связаться с нашей службой поддержки и открыть заявки, вам необходимо создать учетную запись или войти. После этого у вас будет полный доступ к вашей панели поддержки, где вы сможете отслеживать и управлять своими запросами.",
            textLoggedIn: "Вы уже вошли в систему! Теперь вы можете открыть новую заявку в службу поддержки или отслеживать существующие заявки прямо на своей панели.",
            btnLoggedOut: "Создать учетную запись / Войти",
            btnLoggedIn: "Открыть заявку на панели"
        }
    },

    sidebar: {
        main: "Главная",
        dashboard: "Панель управления",
        myBookings: "Мои бронирования",
        myReviews: "Отзывы",
        wishlist: "Список желаний",
        support: "Поддержка",
        finance: "Финансы",
        wallet: "Кошелек",
        payments: "Платежи",
        account: "Аккаунт",
        myProfile: "Мой профиль",
        notifications: "Уведомления",
        settings: "Настройки",
        preferences: "Предпочтения",
        logout: "Выйти",
    },

    agentSidebar: {
        dashboard: "Панель управления",
        bookings: "Бронирования",
        tukTukBookings: "Бронирования тук-туков",
        hotelBookings: "Бронирования отелей",
        carBookings: "Бронирования автомобилей",
        cruiseBookings: "Бронирования круизов",
        tourBookings: "Бронирования туров",
        flightBookings: "Бронирования рейсов",
        enquiries: "Запросы",
        earnings: "Заработки",
        reviews: "Отзывы",
        support: "Поддержка",
        serviceEnrollment: "Регистрация услуг",
        drivers: "Водители",
        tukTukVehicles: "Транспортные средства тук-тук",
        settings: "Настройки",
        logout: "Выйти",
    },

    dashboardCards: {
        totalBookings: "Всего купленных пакетов",
        totalListings: "Всего пакетов",
        totalEarnings: "Общий доход",
        totalReviews: "Всего отзывов",
    },

    recentlyadded: {
        titulo: "Недавно добавленные",
    },

    BookingsStatistics: {
        titulo: "Статистика бронирований",
        loading: "Загрузка статистики...",
        none: "Пока нет зарегистрированных бронирований.",
    }
};